<div class="relative navbar shadow-sm">
  <div class="navbar-start flex gap-2">
    <a class="btn btn-ghost text-sm flex items-center gap-2" [class]="{ 'cursor-pointer': adminLabel() }" [routerLink]="'/home'">
      <img alt="skilltree_logo" src="assets/logo/skillTree-logo-dark.png" class="w-10 h-10 object-contain" />
      SkillTree {{ adminLabel() ? 'Admin' : '' }}
    </a>
    <a
      routerLink="../home"
      class="btn btn-ghost text-sm flex items-center gap-2 relative"
      routerLinkActive="before:content-[' '] before:bg-orange-500 dark:before:bg-orange-500 before:absolute before:w-[50%] before:h-[.25rem] before:bottom-[-.75rem] before:rounded-t-sm before:translate-x-[-50%] before:left-[50%] before:pointer-events-none"
    >
      Skills
    </a>
    <a
      routerLink="../certificate"
      class="btn btn-ghost text-sm flex items-center gap-2 relative"
      routerLinkActive="before:content-[' '] before:bg-orange-500 dark:before:bg-orange-500 before:absolute before:w-[50%] before:h-[.25rem] before:bottom-[-.75rem] before:rounded-t-sm before:translate-x-[-50%] before:left-[50%] before:pointer-events-none"
    >
      Zertifikate
    </a>
    <a
      routerLink="../profile"
      class="btn btn-ghost text-sm flex items-center gap-2 relative"
      routerLinkActive="before:content-[' '] before:bg-orange-500 dark:before:bg-orange-500 before:absolute before:w-[50%] before:h-[.25rem] before:bottom-[-.75rem] before:rounded-t-sm before:translate-x-[-50%] before:left-[50%] before:pointer-events-none"
    >
      Profile
    </a>
    @if (hasSubordinates$ | async) {
      <a
        routerLink="../subordinates"
        class="btn btn-ghost text-sm flex items-center gap-2 relative"
        routerLinkActive="before:content-[' '] before:bg-orange-500 dark:before:bg-orange-500 before:absolute before:w-[50%] before:h-[.25rem] before:bottom-[-.75rem] before:rounded-t-sm before:translate-x-[-50%] before:left-[50%] before:pointer-events-none"
      >
        Mein Team
      </a>
    }
  </div>
  <div class="navbar-end flex gap-2 pr-5">
    @if (viewDataService.$employeeView(); as foreignEmployee) {
      <div
        class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 grid w-75 grid-cols-[40px_1fr_40px] items-center rounded-full border p-1 bg-primary"
      >
        <div class="flex justify-center">
          <if-profile-picture [employee]="foreignEmployee"></if-profile-picture>
        </div>
        <div class="pl-6">
          <div class="text-sm font-light">Aktuelle Ansicht als</div>
          <div class="text-sm font-semibold">{{ `${foreignEmployee.firstname} ${foreignEmployee.lastname}` }}</div>
        </div>
        <button
          aria-label="Fremde Ansicht verlassen und zu eigenem SkillTree zurückkehren"
          class="flex justify-center"
          (click)="viewDataService.$employeeView.set(undefined)"
        >
          <ng-icon name="heroXMark" size="20" strokeWidth="2"></ng-icon>
        </button>
      </div>
    }
    <if-notification-center />
    <if-skill-certificate-confirmation />
    <if-profile-dropdown />
  </div>
</div>
